import { Component, HostListener, ViewEncapsulation } from "@angular/core";
import { MatDialog as MatDialog } from "@angular/material/dialog";
import { DomSanitizer, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
// @ts-ignore
import _ from "lodash";
import { AlertService } from "src/app/services/alert.service";
import { LoaderService } from "src/app/services/loader.service";
import { AbstractSplitView } from "../abstract-split-view/abstract-split-view";
import { ProofreadingService } from "src/app/services/proofreading.service";
import { LivecoAPIService } from "src/app/services/liveco-api.service";
import { AuthService } from "src/app/services/auth.service";

import { StateMachineService } from "src/app/services/machine-state.service";
import { ProjectService } from "src/app/services/project.service";
import { MembersService } from "src/app/services/member.service";
import { ProductionTextsService } from "src/app/services/production-texts.service";
import { MarqueService } from "src/app/services/marque.service";
import { Marque } from "src/app/models/marque.model";
import { FlowType } from "src/app/models/proofreading.model";
// @ts-ignore
// const api = require("@modules/cf-api.js").api;
// const api_async = require("@modules/cf-api.js").api_async;

@Component({
    selector: "app-split-view",
    templateUrl: "./split-view.page.html",
    styleUrls: ["./split-view.page.scss"],
    encapsulation: ViewEncapsulation.None
})
export class SplitViewComponent extends AbstractSplitView {

    get noUrl(): boolean {
        return !this.url || this.isPlaceHolderViewLink;
    }

    get isPlaceHolderViewLink(): boolean {
        return this.view_links.extern.value ? this.view_links.extern.value.match(/\&url\=cloudflow%3a%2f%2fPP_FILE_STORE%2fPublic%2fForm%2fimg%2fdiadem\-logo\.ai\&/ig) !== null : true;
    }

    toggleTextFull: boolean = false;
    get fullWidth(): any {
        return this.toggleTextFull || this.cantReadProofscope || this.noUrl;
    }

    get readOnlyMembers(): boolean {
        return !(this.s_auth.isCPP() || this.s_auth.isFab() || this.current_member?.hasApproDocument);
    }

    get productionTexts() {
        return this.s_productionTexts.current;
    }

    get has_attachements_flow() {
        return this.flow !== FlowType.EZD_EXE && this.flow !== FlowType.EZD_PDF_REPOSITORY && this.flow !== FlowType.BAT;
    }

    get enable_attachments(): boolean {
        return this.s_marques?.current?.flags?.enable_attachments || false;
    }

    canDeactivate(): boolean {
        return !this.productionTexts?.isDifferent;

    }
    
    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any): void {
        if (!this.canDeactivate()) {
            $event.preventDefault();
            $event.returnValue = '';
        }
    }

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected sanitizer: DomSanitizer,
        protected s_alert: AlertService,
        protected dialog: MatDialog,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        protected title: Title,
        protected liveco: LivecoAPIService,
        public s_proofreadings: ProofreadingService,
        protected s_sm: StateMachineService,
        protected s_projects: ProjectService,
        protected s_members: MembersService,
        protected s_productionTexts: ProductionTextsService,
        protected s_marques : MarqueService
    ) {
        super(title, route, router, s_alert, s_loader, s_auth, liveco, s_sm, s_proofreadings, s_projects, s_members, sanitizer, s_marques);
    }

    async retrieveData() {
        super.retrieveData();
    }
}
